import React, { useEffect } from 'react';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getConvertMovieInfo } from 'redux/actions/Convert';
import ConvertDetails from './ConvertDetails';

const ConvertDetailsWrapper = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const params = new URLSearchParams(location.search);
  const movieId = params.get('movie');

  const { convertInfo } = useSelector(({ convert }) => convert);

  useEffect(() => {
    dispatch(getConvertMovieInfo(movieId));
  }, [dispatch, movieId]);

  const breadcrumbs = [
    { label: 'لیست فیلم‌ها', link: '/convert-list' },
    { label: `جزییات تبدیل فیلم`, isActive: true },
  ];

  return (
    <PageContainer breadcrumbs={breadcrumbs} heading={`بارگذاری و تبدیل فیلم`}>
      {convertInfo && <ConvertDetails convertInfo={convertInfo} />}
    </PageContainer>
  );
};

export default ConvertDetailsWrapper;
